var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSavedRound = function SvgSavedRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.5,
    fill: "#FCFCFF",
    stroke: "#DDDFE5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#saved-round_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#saved-round_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#saved-round_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2B2A35",
    d: "M26 12H16c-1.1 0-2 .9-2 2v16l7-3 7 3V14c0-1.1-.9-2-2-2Zm0 15-5-2.18L16 27V14h10v13Z"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "saved-round_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 9h24v24H9z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "saved-round_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 9h24v24H9z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "saved-round_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 9h24v24H9z"
  })))));
};
export default SvgSavedRound;